// extracted by mini-css-extract-plugin
export default {"save_icon":"social-actions-SaveAction__save_icon--38Fb8"};